import { TimberService } from "@logging/timber.service";
import { inject } from "@nodeModules/@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@nodeModules/@angular/router";
import { FeaturesToggleSettingsService } from "app/featuresToggleSettings/service/featuresToggleSettings.service";
import { FeatureToggle } from "@shared/enums";
import { Observable, of, take, tap } from "rxjs";

export const IteroPlatformLoginGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot, 
  state: RouterStateSnapshot
): Observable<boolean> => {
    const featuresToggleSettingsService = inject(FeaturesToggleSettingsService);
    const timberService = inject(TimberService);

    timberService.info(`Login callback was triggered.`, { module: 'IteroPlatformLoginGuard' });
    const stateParam = route?.queryParamMap?.get('state');
    const loginHintParam = route?.queryParamMap.get('login_hint');
    const sessionIdParam = route?.queryParamMap?.get('session_id');

    if (!stateParam || !loginHintParam || !sessionIdParam) {
        timberService.info(`Missing query params. state: ${stateParam}, login hint: ${loginHintParam}, session id: ${sessionIdParam}.`, { module: 'IteroPlatformLoginGuard' });
        return of(false);
    }

    return featuresToggleSettingsService.isVisibleFeature$(FeatureToggle.UseIteroPlatformLogin)
        .pipe(take(1), tap(res => {
            let isAllowed = res ? 'allowed' : 'not allowed';
            timberService.info(`UseIteroPlatformLogin value is ${res}. login-callback route is ${isAllowed}.`, { module: 'IteroPlatformLoginGuard' });
        }));
}